import React, { Component } from "react";
import { check_all_releases } from "../../resources/string/strings"
import { Link } from "react-router-dom";

class Adapter extends Component {
  state = {
  };

  render() {
    const { categoryId, pictureUrl, titleFa, titleEn, showMoreLink } = this.props;

    return (
      <div className="row " 
        style={{ 
          marginLeft: 0, 
          paddingLeft: 0 
        }}>

        <div style={{ 
          marginRight: 0 
        }} className="row col-8 ">

          <img
            style={{ width: 40, height: 40 }}
            className="p-0 m-0 m-r"
            src={pictureUrl}
            alt=""
          />

          <div className="col-8" >

            <div style={{ color: "black", fontSize: 15, textAlign: "right" }}>
              {titleFa}
            </div>

            <div style={{ color: "gray", fontSize: 12, textAlign: "right" }}>
              {titleEn}
            </div>

          </div>
        </div>

        {showMoreLink !== undefined && showMoreLink &&
          <Link
          to={"/releases/list?ci=" + categoryId + "&t=" + titleFa + "&cp=" + pictureUrl} 
           className="col-4 clickable "
           style={{
            color: "seagreen",
            textAlign: "left",
            fontSize: 11,
            marginTop: 10,
            paddingLeft: 0,
            fontStyle: "italic",
            textDecoration: "none"
          }}>
            {check_all_releases}
          </Link>
        }

      </div>

    );
  }
}

export default Adapter;
